import React from "react";
import { Grid, IconButton, Typography } from "@mui/material";
import Auth from '../firebase/Authentication';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from "react-router-dom";
var currencyFormatter = require("currency-formatter");


function ArrivalsCard({ sx, backgroundImage, name, price, itemId }) {
  const navigate = useNavigate();
  let cprice = currencyFormatter.format(parseInt(price), {
    symbol: "UGX",
    precision: 0,
    format: "%v %s", // %s is the symbol and %v is the value
  });
  return (
    <>
      <Grid
        item
        xs={11}
        md={2.5}
        sx={{
          ...sx,
          height: "500px",
          padding: "10px",
          borderColor: { md: "grey.400" },
        }}
      >
        <div
          onClick={() => navigate(`/item/${itemId}`)}
          style={{
            backgroundImage: `url(${backgroundImage})`,
            backgroundSize: "cover",
            backgroundPosition: "center center",
            display: "flex",
            height: "85%",
            width: "100%",
            position: "relative",
          }}
        ></div>
        <Grid container>
          <Grid item xs={8}>
            <div className="mt-2 mb-[-10px]">
              <Typography>{name}</Typography>
              <Typography>{cprice}</Typography>
            </div>
          </Grid>
          <Grid item xs={4}>
            {Auth.getUser() != null ?
              <IconButton onClick={() => navigate(`/edititem/${itemId}`)} className="text-right">
                <EditIcon sx={{ fontSize: "40px", color: "white" }} className="rounded-full text-[20px] bg-blue-500 p-1" />
              </IconButton> :
              null
            }
          </Grid>
        </Grid>
      </Grid>

    </>
  );
}

export default ArrivalsCard;
